import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.min.css";
import Slide1 from "../assets/Video/hair.mp4";
import Slide2 from "../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4";
import Slide3 from "../assets/Video/meical video.mp4";
import "../assets/css/HeroSection.css"; // External CSS file
import { useNavigate } from "react-router-dom";


const HeroSection = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // Ensure Bootstrap carousel auto-initializes
    const bootstrap = require("bootstrap");
    const carouselEl = document.querySelector("#HeroSection");
    new bootstrap.Carousel(carouselEl, {
      interval: 5000,
      ride: "carousel",
    });
  }, []);

  return (
    <div
      id="HeroSection"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
      data-bs-interval="7000"
    >
      <div className="carousel-inner">


        {/* Slide 2 (Video) */}
        <div className="carousel-item active">
          <video
            className="d-block w-100 hero-media"
            autoPlay
            muted
            loop
            playsInline
          >
            <source
              src={Slide2}
              type="video/mp4"
            />
          </video>
          <div className="carousel-caption text-start animate__animated animate__fadeInUp">
            <h3>Skin Care</h3>
            <p>"Science-backed solutions for radiant skin"</p>
            <a href="#" className="btn btn-primary" onClick={() => navigate("/Skin-Care-Products")} target="_blank">
              Explore Now
            </a>
          </div>
        </div>

        {/* Slide 1 (Video) */}
        <div className="carousel-item ">
          <video
            className="d-block w-100 hero-media"
            autoPlay
            muted
            loop
            playsInline
          >
            <source
              src={Slide1}
              type="video/mp4"
            />
          </video>
          <div className="carousel-caption text-start animate__animated animate__fadeInUp">
            <h3>Hair Care</h3>
            <p>"Hair health Rooted in Molecular Science"</p>
            <a href="#" className="btn btn-primary" onClick={() => navigate("/HairCareProducts")} target="_blank">
              Explore Now
            </a>
          </div>
        </div>

        {/* Slide 3 (Video) */}
        <div className="carousel-item ">
          <video
            className="d-block w-100 hero-media"
            autoPlay
            muted
            loop
            playsInline
          >
            <source
              src={Slide3}
              type="video/mp4"
            />
          </video>
          <div className="carousel-caption text-start animate__animated animate__fadeInUp">
            <h3>Medical Engineering</h3>
            <p>"Engineering Biology Into Clinical Precision"</p>
            <a href="#" className="btn btn-primary" onClick={() => navigate("/MedicalEnggProducts")} target="_blank">
              Explore Now
            </a>
          </div>
        </div>


        {/* Slide 4 (Image) */}
        {/* <div className="carousel-item">
          <img
            src={Slide4}
            className="d-block w-100 hero-media"
            alt="Hair Care"
          />
          <div className="carousel-caption text-start animate__animated animate__fadeInUp">
            <h3>Hair Care</h3>
            <p>"Hair health Rooted in Molecular Science"</p>
            <a href="#" className="btn btn-primary">
              Explore Now
            </a>
          </div>
        </div> */}

      </div>

      {/* Navigation Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#HeroSection"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon"></span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#HeroSection"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon"></span>
      </button>
    </div>
  );
};

export default HeroSection;
